<template>
	<div id="formdisplay" :class="(isEmbed ? 'embed' : '')">
		<div v-if="!isEmbed" class="row">
			<div class="formLogo" ><img v-if="FormDefinition('FormLogo')" :src="FormDefinition('FormLogo')" alt="Logo"/></div>
			<div class="formTitle" :style="'color: ' + FormDefinition ('HeaderColor')">{{ FormDefinition ('FormTitle') }}</div>
		</div>
		<div v-if="FormDefinition('DisableForm') != 'y' && formHasData" class="row wizard-form" >
			<el-steps v-if="!completed" :active="activeStep" process-status="process" align-center finish-status="success">
				<template v-for="(item, index) in FormDefinition ('FormSteps')">
					<el-step
	                     v-if="showCondition('Step' + (index+1))"
	                     :title="stepName(index)"
	                     :key="'Step '+ (index+1)"
	                     :status="stepStatus[index+1]"
	                     :description="item.StepDesc">
					</el-step>
				</template>
			</el-steps>
			<el-form v-if="!completed" v-loading="loading" ref="paymentForm" label-position="top" :model="form" :rules="rules" label-width="120px" size="default" >
				<template v-for="(item, index) in FormDefinition ('FormSteps')">
				<div v-if="activeStep == index" class="row form-group col-12">
				<div v-if="item.StepMessage" class="col-12">
					<div class="formMessage" v-html="item.StepMessage" >
					</div>
				</div>
					<template v-for="(field, fieldIndex) in item.StepFields">
					<div v-if="activeStep == index" class="fieldGrouping col-12">
                    <div v-if="field.value == 'program'  && showCondition(field.value)"  class="col-12">
                        <el-form-item label="Program" prop="ProgramID"
                                        :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Program is required', trigger: 'blur'}]"
                        >
                            <el-select v-model="form.ProgramID" placeholder="Select" clearable default-first-option filterable>
                                <el-option
                                    v-for="item in FormPrograms"
                                    :label="item.ProgramName"
                                    :value="item.ProgramID"
                                    :key="item.ProgramID">
                                </el-option>
                            </el-select>
                        </el-form-item>
		            </div>
		            <div v-if="field.value == 'team'  && showCondition(field.value)"  class="col-12">
                        <template v-if="FormDefinition ('ShowTeamProgram') != 'y' || form.TeamID">
                            <el-form-item :label="'Team Name' + (FormDefinition ('MultiTeam') == 'y' ? ' (Select one or more) ' : '')" prop="TeamID"
                                :rules="[{ required: (field.hasOwnProperty('required') && !form.TeamID ? field.required : false), message: 'Team Name is required', trigger: 'blur'}]"
                            >
                                <el-select v-model="form.TeamID" placeholder="Select" :disabled="(player && player.PlayerID > 0 && player.TeamName ? true : false) || disableTeam" :multiple="formDefinition && formDefinition.MultiTeam == 'y'" @change="teamChanged" clearable default-first-option filterable>
                                    <el-option
                                        v-for="item in Teams"
                                        :label="item.TeamName"
                                        :value="item.TeamID"
                                        :key="item.TeamID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item :label="config.Params.programName" prop="ProgramID">
                                <el-select v-model="form.ProgramID" placeholder="Select" :disabled="(player && player.PlayerID > 0 && player.TeamName ? true : false)" @change="programChanged" default-first-option filterable>
                                    <el-option
                                        v-for="item in FormPrograms"
                                        :label="item.ProgramName"
                                        :value="item.ProgramID"
                                        :key="item.ProgramID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="'Team' + (FormDefinition ('MultiTeam') == 'y' ? ' (Select one or more) ' : '')" prop="TeamName"
                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Team Name is required', trigger: 'blur'}]"
                            >
                                <el-select v-model="form.TeamID" placeholder="Select" :disabled="(player && player.PlayerID > 0 && player.TeamName ? true : false) || disableTeam" :multiple="formDefinition && formDefinition.MultiTeam == 'y'" @change="teamChanged" clearable default-first-option filterable>
                                    <el-option
                                        v-for="item in FormProgramTeams[form.ProgramID]"
                                        :label="item.TeamName"
                                        :value="item.TeamID"
                                        :key="item.TeamID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
		            </div>
                    <div v-if="field.value == 'organization'  && showCondition(field.value)"  class="col-12">
                        <el-form-item label="Organization" prop="OrganizationID"
                            :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Organization is required', trigger: 'blur'}]"
                        >
                            <el-select v-model="form.OrganizationID" placeholder="Select" :disabled="disableOrganization" @change="organizationChanged" default-first-option filterable>
                                <el-option
                                    v-for="item in Organizations"
                                    :label="item.OrganizationName"
                                    :value="item.OrganizationID"
                                    :key="item.OrganizationID">
                                </el-option>
                            </el-select>
                        </el-form-item>
		            </div>
                    <div v-if="field.value == 'playername'  && showCondition(field.value)"  class="col-12">
                        <el-form-item label="Player First Name" prop="PlayerFirstName"
                                      :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Player First Name is required', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.PlayerFirstName" :disabled="(player && player.PlayerID > 0 ? true : false)" type="text" :formatter="(value) => `${value}`.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')" :parser="(value) => value.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')"></el-input>
                        </el-form-item>
                        <el-form-item label="Player Last Name" prop="PlayerLastName"
                                      :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Player Last Name is required', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.PlayerLastName" :disabled="(player && player.PlayerID > 0 ? true : false)" type="text" :formatter="(value) => `${value}`.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')" :parser="(value) => value.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')"></el-input>
                        </el-form-item>
                    </div>
                    <div v-if="field.value == 'name'  && showCondition(field.value)"  class="col-12">
                        <el-form-item label="First Name" prop="FirstName"
                                      :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'First Name is required', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.FirstName" type="text" :formatter="(value) => `${value}`.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')" :parser="(value) => value.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')"></el-input>
                        </el-form-item>
                        <el-form-item label="Last Name" prop="LastName"
                                      :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Last Name is required', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.LastName" type="text" :formatter="(value) => `${value}`.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')" :parser="(value) => value.replace(/[^a-zA-Z0-9\'\-\. ]/g, '')"></el-input>
                        </el-form-item>
                    </div>
                    <div v-if="field.value == 'playerregistrationapprovalcode'  && showCondition(field.value)"  class="col-12">
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
                            <el-form-item label="Player Registration No." prop="PlayerRegistrationApprovalCode"  :class="{'is-error' : playerregistrationapprovalcodeerror}">
                                <el-input v-model="form.PlayerRegistrationApprovalCode" @change="validatePlayerRegistrationApprovalCode" v-on:blur="validatePlayerRegistrationApprovalCode" :disabled="playerregistrationapprovalcodedisable"></el-input>
                                <div v-if="playerregistrationapprovalcodeinvalid" class="el-form-item__error one" v-html="PlayerRegistrationApprovalCodeErrorMessage"></div>
                                <div v-else-if="playerregistrationapprovalcoderequired" class="el-form-item__error two">
                                    Player Registration No. is required
                                </div>
                            </el-form-item>
                        </div>
                    </div>
		            <div v-if="field.value == 'playerdob' && showCondition(field.value)"  class="col-12">
						<div class="el-form-item el-form-item--default" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
							<el-form-item label="Player's DOB" prop="PlayerDOB"
							>
								<form-date size="default" v-model="form.PlayerDOB" :disableDate="(player && player.PlayerID > 0 && player.Params.DOB ? true : false)" />
							</el-form-item>
						</div>
	                </div>
					<div v-if="field.value == 'address' && showCondition(field.value)" class="col-12">
		                <el-form-item label="Street" prop="AddressStreet"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Street is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.AddressStreet">
		                    </el-input>
		                </el-form-item>
		                <el-form-item label="Apt." prop="AddressApt">
		                    <el-input v-model="form.AddressApt">
		                    </el-input>
		                </el-form-item>
		                <el-form-item label="City" prop="AddressCity"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'City is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.AddressCity">
		                    </el-input>
		                </el-form-item>
		                <el-form-item :label="config.Params.state" prop="AddressState"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: config.Params.state + ' is required', trigger: 'change'}]"
		                >
							<el-select v-model="form.AddressState" placeholder="Select" default-first-option filterable clearable @change="setAddressCountry">
								<el-option-group
										v-for="country in StateProvinceCodes"
										:key="country.Country"
										:label="country.Country">
									<el-option
											v-for="state in country.States"
											:key="state.StateProvinceCodeShortName"
											:label="state.StateProvinceCodeName"
											:value="state.StateProvinceCodeShortName">
									</el-option>
								</el-option-group>
							</el-select>
		                </el-form-item>
		                <el-form-item :label="config.Params.zipcode" prop="AddressZipCode"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: config.Params.zipcode + ' is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.AddressZipCode" class="zipcode">
		                    </el-input>
		                </el-form-item>
		            </div>
		            <div v-if="field.value == 'contact' && showCondition(field.value)"  class="col-12">
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
			                <el-form-item label="Phone (Evening)" prop="PhoneEvening"
                                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Phone (Evening) is required', trigger: 'blur'}]"
		                    >
			                    <div class="el-form-item__content">
			                        <div class="el-input el-input--default el-input__wrapper">
			                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.PhoneEvening" />
			                        </div>
			                    </div>
			                </el-form-item>
		                </div>
		                <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
			                <el-form-item label="Phone (Daytime)" prop="PhoneDaytime"
                                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Phone (Daytime) is required', trigger: 'blur'}]"
                            >
			                    <div class="el-form-item__content">
			                        <div class="el-input el-input--default el-input__wrapper">
			                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.PhoneDaytime" />
			                        </div>
			                    </div>
			                </el-form-item>
			            </div>
		                <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
			                <el-form-item label="Mobile Phone" prop="CellPhoneNumber"
                                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Mobile Phone is required', trigger: 'blur'}]"
                            >
			                    <div class="el-form-item__content">
			                        <div class="el-input el-input--default el-input__wrapper">
			                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.CellPhoneNumber" />
			                        </div>
			                    </div>
			                </el-form-item>
			            </div>
		                <el-form-item label="Email" prop="Email"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Email is required', trigger: 'blur'},
		                             { type: 'email',  message: 'Email is invalid', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.Email" :disabled="(player && player.PlayerID > 0 && player.EmailAddress ? true : false)">
		                    </el-input>
		                </el-form-item>
		            </div>
                    <div v-if="field.value == 'phone' && showCondition(field.value)"  class="col-12">
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
                            <el-form-item label="Phone (Evening)" prop="PhoneEvening"
                                :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Phone (Evening) is required', trigger: 'blur'}]"
                            >
                                <div class="el-form-item__content">
                                    <div class="el-input el-input--default el-input__wrapper">
                                        <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.PhoneEvening" />
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
                            <el-form-item label="Phone (Daytime)" prop="PhoneDaytime"
                                :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Phone (Daytime) is required', trigger: 'blur'}]"
                            >
                                <div class="el-form-item__content">
                                    <div class="el-input el-input--default el-input__wrapper">
                                        <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.PhoneDaytime" />
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
			                <el-form-item label="Mobile Phone" prop="CellPhoneNumber"
                               :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Mobile Phone is required', trigger: 'blur'}]"
                            >
			                    <div class="el-form-item__content">
			                        <div class="el-input el-input--default el-input__wrapper">
			                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.CellPhoneNumber" />
			                        </div>
			                    </div>
			                </el-form-item>
			            </div>
                    </div>
                    <div v-if="field.value == 'mobile' && showCondition(field.value)"  class="col-12">
                        <div class="el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
			                <el-form-item label="Mobile Phone" prop="CellPhoneNumber"                                
                                :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Mobile Phone is required', trigger: 'blur'}]"
                            >
			                    <div class="el-form-item__content">
			                        <div class="el-input el-input--default el-input__wrapper">
			                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form.CellPhoneNumber" />
			                        </div>
			                    </div>
			                </el-form-item>
			            </div>
                    </div>
                    <div v-if="field.value == 'email' && showCondition(field.value)"  class="col-12">
                        <el-form-item label="Email" prop="Email"
                                      :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Email is required', trigger: 'blur'},
		                             { type: 'email',  message: 'Email is invalid', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.Email" :disabled="(player && player.PlayerID > 0 && player.EmailAddress ? true : false)">
                            </el-input>
                        </el-form-item>
                    </div>
                    <el-form-item v-if="field.value == 'waiver' && showCondition(field.value)" class="col-12" prop="waiver">
		            	<h5>Waiver</h5>
						<div class="waiverMessage" v-html="FormDefinition('WaiverText')" >
						</div>
						<el-checkbox v-model="form.waiver">I Accept</el-checkbox>
					</el-form-item>
					<div v-if="field.value == 'paymentamount' && showCondition(field.value)" class="col-12" style="position: relative;">
						<div class="PaymentAmount">
			                <el-form-item label="Payment Amount" prop="PaymentAmount"
	                            :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Payment Amount is required', trigger: 'blur'}]"
	                        >
	                            <el-input type="number" v-model="form.PaymentAmount" class="InputPaymentAmount" :disabled="FormDefinition('FormPayment') || !AllowPaymentInput">
		                            <template #prepend><span v-html="currencySign"></span></template>
	                            </el-input>
	                        </el-form-item>
			            </div>
                        <div v-if="FormDefinition('ServiceCharge') > 0 && FormDefinition('ShowServiceCharge') == 'y'" class="ServiceCharge" v-html="'A service charge of ' + (FormDefinition('ServiceChargeType') == 'Flat' ? '$'+ FormDefinition('ServiceCharge') : FormDefinition('ServiceCharge') + '%' ) + ' will be added to your payment'"></div>
			        </div>

					<div v-if="field.value == 'paymentdetails' && showCondition(field.value)" class="col-12">
		                <el-form-item label="Name on Card" prop="PaymentNameOnCard"
                            :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Name on Card is required', trigger: 'blur'}]"
                        >
                            <el-input v-model="form.PaymentNameOnCard">
                            </el-input>
                        </el-form-item>
						<div class="ccTypes">
							<span v-if="FormDefinition('AllowedCards').indexOf('Visa') !== -1" :class="{ 'color-primary' : isVisa }"><i class="fab fa-cc-visa"></i></span>
							<span v-if="FormDefinition('AllowedCards').indexOf('Mastercard') !== -1" :class="{ 'color-primary' : isMastercard }"><i class="fab fa-cc-mastercard"></i></span>
							<span v-if="FormDefinition('AllowedCards').indexOf('Amex') !== -1" :class="{ 'color-primary' : isAmex }"><i class="fab fa-cc-amex"></i></span>
							<span v-if="FormDefinition('AllowedCards').indexOf('Discover') !== -1" :class="{ 'color-primary' : isDiscover }"><i class="fab fa-cc-discover"></i></span>
						</div>
						<el-form-item label="Credit Card Number" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}" prop="PaymentCardNumber">
							<el-input v-model="form.PaymentCardNumber">
							</el-input>
						</el-form-item>
		                <div class="expiryDate el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}">
		                    <el-form-item label="Expiry Date" prop="ExpiryDate"
		                    >
		                        <div class="el-form-item__content">
		                            <div class="el-input el-input--default el-input__wrapper">
		                                <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'##/##'" v-model="form.ExpiryDate" />
		                            </div>
		                        </div>
		                    </el-form-item>
			            </div>
						<div class="expiryDate el-form-item" :class="{'is-required' : (field.hasOwnProperty('required') ? field.required : false)}" style="margin-bottom: 22px;">
							<el-form-item label="CVV" prop="CVV"
							>
								<div class="el-form-item__content">
									<div class="el-input el-input--default el-input__wrapper">
										<input autocomplete="off" class="el-input__inner" type="tel" v-maska="'####'" v-model="form.CVV" />
									</div>
								</div>
							</el-form-item>
						</div>
		                <el-checkbox v-if="form.AddressStreet" v-model="sameAddress" @change="processSameAddress" >Same Address as Main Contact</el-checkbox>
		                <el-form-item label="Street" prop="PaymentStreet"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'Street is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.PaymentStreet">
		                    </el-input>
		                </el-form-item>
		                <el-form-item label="Apt." prop="PaymentApt">
		                    <el-input v-model="form.PaymentApt">
		                    </el-input>
		                </el-form-item>
		                <el-form-item label="City" prop="PaymentCity"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: 'City is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.PaymentCity">
		                    </el-input>
		                </el-form-item>
		                <el-form-item :label="config.Params.state" prop="PaymentState"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: config.Params.state + ' is required', trigger: 'change'}]"
		                >
							<el-select v-model="form.PaymentState" placeholder="Select" default-first-option filterable clearable @change="setPaymentCountry">
								<el-option-group
										v-for="country in StateProvinceCodes"
										:key="country.Country"
										:label="country.Country">
									<el-option
											v-for="state in country.States"
											:key="state.StateProvinceCodeShortName"
											:label="state.StateProvinceCodeName"
											:value="state.StateProvinceCodeShortName">
									</el-option>
								</el-option-group>
							</el-select>
						</el-form-item>
		                <el-form-item :label="config.Params.zipcode" prop="PaymentZipCode"
		                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: config.Params.zipcode + ' is required', trigger: 'blur'}]"
		                >
		                    <el-input v-model="form.PaymentZipCode" class="zipcode">
		                    </el-input>
		                </el-form-item>
					</div>
					<div v-if="field.value == 'captcha' && showCondition(field.value)">
						<div class="sample-captcha">
							<el-form-item label="Please enter the CAPTCHA value below (case sensitive)" prop="captchavalue">
								<el-input v-model="form.captchavalue" class="vue_client_recaptcha_input">
								</el-input>
								<div style="width: 1000%;">
									<VueClientRecaptcha
										:value="form.captchavalue"
										chars="23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz"
										custom-text-color="black"
										@isValid="isCaptchaValid"
									/>
								</div>
							</el-form-item>
						</div>
					</div>
                    <div v-if="field.value == 'openice' && showCondition(field.value)">
                        <div class="row">
                            <template v-if="!isNaN(FormDefinition('MaximumIceRentals')) && parseInt(FormDefinition('MaximumIceRentals')) > 0 && rentalsSelected >= FormDefinition('MaximumIceRentals')">
                                <div class="MaximumRentals">** You have reached the Maximum Number of Rentals Permitted **</div>
                            </template>
                            <template v-else>
                                <div class="col-12 col-md-5">
                                    Date:<br>
                                    <el-date-picker
                                        style="width: 95%;"
                                        v-model="searchDates"
                                        type="daterange"
                                        unlink-panels
                                        clearble
                                        range-separator="To"
                                        start-placeholder="Start date"
                                        end-placeholder="End date"
                                        format="MMM D, YYYY"
                                        value-format="YYYYMMDD">
                                    </el-date-picker>
                                </div>
                                <div class="col-12 col-md-4">
                                    {{config.Params.locationName}}:<br>
                                    <el-select v-model="searchMainLocationName"  placeholder="All" class="search" default-first-option filterable clearable>
                                        <el-option
                                            v-for="item in MainLocationNames"
                                            :label="item"
                                            :value="item"
                                            :key="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="col-12 col-md-3">
                                    &nbsp;<br>
                                    <el-input
                                        class="search"
                                        v-model="search"

                                        clearable
                                        placeholder="Type to search"/>
                                </div>
                            </template>
                        </div>
                        <el-form-item label="" prop="openiceselected" style="width: 100%;">
                            <el-select v-model="form.openiceselected" class="openice" multiple style="display:none;"></el-select>
                        </el-form-item>
                        <el-table
                            :data="TeamOpenIce.filter(data => (data.NumAttendees && data.NumAttendees > 0)
                                            || (
                                                (!searchDates || !searchDates[0] || (parseInt(searchDates[0]) <= parseInt(data.GameDate.replace(/-/g,''))))
                                            &&  (!searchDates || !searchDates[1] || (parseInt(searchDates[1]) >= parseInt(data.GameDate.replace(/-/g,''))))
                                            &&  (!search || (search && data.StartTime.toLowerCase().includes(search.toLowerCase()))
                                                         || (search && data.LocationName.toLowerCase().includes(search.toLowerCase()))
                                                         || (search && data.Title.toLowerCase().includes(search.toLowerCase())))
                                            && (!searchMainLocationName || (searchMainLocationName && data.MainLocationName.toLowerCase().includes(searchMainLocationName.toLowerCase())))
                                                )
                                            )"
                            key="openice"
                            ref="openicetable"
                            row-key="CalendarSlotID"
                            :sort-method="sortTimeSlotGameDate"
                            :row-class-name="tableRowClassName"
                            :max-height="maxHeight"
                            empty-text="No Times"
                            stripe border
                            size="default"
                            style="width: 100%">
                            <el-table-column
                                v-if="FormDefinition('OpenIceType') == 'r'"
                                label="Sel"
                                align="center"
                                width="60"
                            >
                                <template #default="scope">
                                    <input v-if="!scope.row.FormDataID && scope.row.TeamIDs != ''" type="checkbox" v-model="scope.row.selected" :disabled="scope.row.FormDataID || (!scope.row.selected && !isNaN(FormDefinition('MaximumIceRentals')) && parseInt(FormDefinition('MaximumIceRentals')) > 0 && rentalsSelected >= FormDefinition('MaximumIceRentals')) || (FormDefinition ('LinkToTeam') == 'y' && SelectedTeamID == '')" @change="selectionChanged(scope.row)" />
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="FormDefinition('OpenIceType') == 'p'"
                                prop="Title"
                                label="Event"
                                min-width="130"
                                align="left"
                                sortable
                            >
                                <template #default="scope">
                                    <div v-html="scope.row.Title"></div>
                                    <div class="description" v-html="scope.row.Description"></div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="GameDateF"
                                :label="(isMobile ? 'Date / Time' : 'Date')"
                                min-width="130"
                                align="left"
                                sortable
                                :sort-method="sortTimeSlotGameDate"
                            >
                                <template #default="scope">
                                    <div v-html="(isMobile ? scope.row.GameDateF+'<br>'+scope.row.StartTime+'<br>'+(scope.row.Duration - scope.row.GameSetup)  + ' min.' : scope.row.GameDateF)"></div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!isMobile"
                                prop="StartTime"
                                label="Time"
                                min-width="80"
                                align="left"
                                sortable
                                :sort-method="sortTimeSlotGameTime"
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="!isMobile"
                                prop="Duration"
                                label="Duration"
                                min-width="80"
                                align="left"
                            >
                                <template #default="scope">
                                    <div v-html="(scope.row.Duration - scope.row.GameSetup)  + ' min.'"></div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="LocationName"
                                :label="(isMobile ? config.Params.locationName + ' / Fee': config.Params.locationName)"
                                min-width="130"
                                align="left"
                                sortable
                            >
                                <template #default="scope">
                                    <div v-html="scope.row.LocationName"></div>
                                    <template v-if="isMobile">
                                        <div v-if="!scope.row.FormDataID" v-html="formatPrice(scope.row.Fee)"></div>
                                        <div v-else v-html="'** Booked **'"></div>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!isMobile"
                                prop="Fee"
                                label="Fee"
                                align="right"
                                min-width="100"
                            >
                                <template #default="scope">
                                    <div v-if="!scope.row.FormDataID" v-html="formatPrice(scope.row.Fee)"></div>
                                    <div v-else v-html="'** Booked **'"></div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!isMobile && FormDefinition('CustomPayments') && FormDefinition('CustomPayments').length > 0 "
                                prop="DiscountFee"
                                label="Discounted Fee"
                                align="right"
                                min-width="100"
                            >
                                <template #default="scope">
                                    <div v-if="!scope.row.FormDataID" v-html="formatPrice(scope.row.DiscountedFee)"></div>
                                    <div v-else></div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                v-if="FormDefinition('OpenIceType') == 'p'"
                                prop="Availability"
                                label="Spots Remaining"
                                width="100"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="FormDefinition('OpenIceType') == 'p'"
                                prop="NumAttendees"
                                label="Number"
                                width="90"
                                align="center"
                            >
                                <template #default="scope">
                                    <el-input type="text" size="default" v-model="scope.row.NumAttendees"  class="smallNumber" @keyup="NumAttendeesChanged(scope.row.CalendarSlotID)" ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="FormDefinition('OpenIceType') == 'p'"
                                prop="Names"
                                label="Attendees"
                                min-width="200"
                                align="center"
                            >
                                <template #default="scope">
                                    <template v-for="Names in scope.row.Attendees">
                                        <el-input type="text" size="default" v-model="Names.FirstName" placeholder="First" style="width: 40%;margin-bottom: 3px;"></el-input><el-input type="text" size="default" v-model="Names.LastName" placeholder="Last Name" style="margin-bottom: 3px;margin-left: 3px;width:55%;"></el-input>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
		            <div v-if="field.custom && field.custom == 'y'" class="col-12">
			            <template v-for="(customField, customFieldIndex) in FormDefinition ('CustomFields')">
				            <div v-if="showCondition(customField.Value)">
								<el-form-item v-if="customField.Value == field.value && (customField.Type == 'select' || customField.Type == 'multiple')" :label="customField.Label" :prop="customField.Value"
											  :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
								>
									<el-select v-model="form[customField.Value]" placeholder="Select" @change="calcPaymentAmount" :disabled="(player && player.PlayerID > 0 && form[customField.Value] && field.value == 'PlayerTypeName' ? true : false)" clearable default-first-option filterable :multiple="(customField.Type == 'multiple' ? true : false)">
										<el-option
												v-for="item in customField.Values "
												:key="item"
												:label="item"
												:value="item">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item v-if="customField.Value == field.value && customField.Type == 'text'" label=""
								>
									<div v-html="customField.Values"></div>
								</el-form-item>
	                            <el-form-item v-if="customField.Value == field.value  && customField.Type == 'input'" :label="customField.Label" :prop="customField.Value"
	                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
	                                <el-input v-model="form[customField.Value]">
	                                </el-input>
	                            </el-form-item>
	                            <el-form-item v-if="customField.Value == field.value  && customField.Type == 'textarea'" :label="customField.Label" :prop="customField.Value"
	                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
	                                <el-input   type="textarea"
	                                            :autosize="{ minRows: 4, maxRows: 20}"
	                                            v-model="form[customField.Value]">
	                                </el-input>
	                            </el-form-item>
                                <el-form-item v-if="customField.Value == field.value  && customField.Type == 'date'" :label="customField.Label" :prop="customField.Value"
                                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
                                >
                                <el-date-picker v-model="form[customField.Value]" default-first-option filterable
									type="date"
					                style="width: 185px"
									format="MMM D, YYYY"
									value-format="YYYY-MM-DD"
									placeholder="">
					            </el-date-picker>
                                </el-form-item>
                                <el-form-item v-if="customField.Value == field.value  && customField.Type == 'email'" :label="customField.Label" :prop="customField.Value"
                                    :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'},
                                            { type: 'email',  message: 'Email is invalid', trigger: 'blur'}]"
                                >
                                    <el-input v-model="form[customField.Value]" >
                                    </el-input>
                                </el-form-item>
                                <el-form-item v-if="customField.Value == field.value  && customField.Type == 'phone'" :label="customField.Label" :prop="customField.Value"
                                            :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
                                    <div class="el-form-item__content">
                                        <div class="el-input el-input--default el-input__wrapper">
                                            <input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="form[customField.Value]" />
                                        </div>
                                    </div>
                                </el-form-item>
	                            <el-form-item v-if="customField.Value == field.value  && customField.Type == 'yesno'" :label="customField.Label" :prop="customField.Value"
	                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
	                                <el-radio-group v-model="form[customField.Value]">
	                                    <el-radio-button selected value="Yes">Yes</el-radio-button>
	                                    <el-radio-button value="No">No</el-radio-button>
	                                </el-radio-group>
	                            </el-form-item>
	                            <el-form-item v-if="customField.Value == field.value  && customField.Type == 'radio'" :label="customField.Label" :prop="customField.Value"
	                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
	                                <el-radio-group v-model="form[customField.Value]" @change="calcPaymentAmount">
	                                    <el-radio v-for="item in customField.Values " :value="item" :key="item">{{item}}</el-radio>
	                                </el-radio-group>
	                            </el-form-item>
	                            <el-form-item v-if="customField.Value == field.value  && customField.Type == 'multiplecheckbox'" :label="customField.Label" :prop="customField.Value"
	                                          :rules="[{ required: (field.hasOwnProperty('required') ? field.required : false), message: customField.Label + ' is Required', trigger: 'blur'}]"
	                            >
	                                <el-checkbox-group v-model="form[customField.Value]" @change="calcPaymentAmount">
	                                    <el-checkbox v-for="item in customField.Values" :label="item" :value="item" :key="item"  @change="calcPaymentAmount"></el-checkbox>
	                                </el-checkbox-group>
	                            </el-form-item>
				            </div>
			            </template>
		            </div>
				</div>
					</template>
                    <template v-if="formHasData">
                        <el-button v-if="index != 0" style="margin-top: 12px;" @click="prev()">Prev step</el-button>
                        <el-button style="margin-top: 12px;" @click="next()">{{ nextButtonText(index) }}</el-button>
                    </template>
				</div>
				</template>
			</el-form>
			<div v-if="completed" class="col-12">
				<span class="ConfirmationMessage" v-html="confirmationMessage"></span>
			</div>
		</div>
        <div v-else-if="!formHasData" class="sorry">
            <el-alert
                :title="(FormDefinition ('OpenIceEmptyMessage') ? FormDefinition ('OpenIceEmptyMessage') : 'Unfortunately, we do not have any availability at this time.')"
                type="info"
                :closable="false"
                show-icon>
            </el-alert>
        </div>
        <div v-else class="sorry">
            <el-alert
                :title="(FormDefinition ('DisableMessage') ? FormDefinition ('DisableMessage') : 'Unfortunately, this form is no longer taking additional entries.')"
                type="info"
                :closable="false"
                show-icon>
            </el-alert>
        </div>
        <div v-if="!isEmbed" class="row">
			<div class="col-12 page-footer" :style="'background-color: ' + FormDefinition ('HeaderColor')">{{ pageFooter }}</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import FormDate from './global/FormDate.vue';
    import Util from "../assets/js/util";
	import VueClientRecaptcha from "../../../node_modules/vue-client-recaptcha/dist/vue-client-recaptcha.es";

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {
		name: 'PaymentForm',
		components: {
			FormDate,
			VueClientRecaptcha,
		},
		data () {
			var validatePhoneNumber = (rule, value, callback) => {
				if (value) {
	                if (value.length != 14) {
	                    callback(new Error('Phone Number must be 10 numbers'));
	                } else {
	                    callback();
	                }
				} else {
					callback();
				}
            };
			var validateExpiryDate = (rule, value, callback) => {
				if (value) {
					if (value.length != 5) {
						callback(new Error('Expiry Date must be 4 numbers'));
					} else {
						callback();
					}
				} else if (this.isRequired('paymentdetails')) {
					callback(new Error('Expiry Date is Required'));
				} else {
					callback();
				}
			};
			var validateCVV = (rule, value, callback) => {
				if (value) {
					if (value.length != 3 && value.length != 4) {
						callback(new Error('CVV must be 3 or 4 numbers'));
					} else {
						callback();
					}
				} else if (this.isRequired('paymentdetails')) {
					callback(new Error('CVV is Required'));
				} else {
					callback();
				}
			};
			var validateCaptcha = (rule, value, callback) => {
				if (value) {
					if (this.captcharesult) {
						callback();
					} else {
						callback(new Error('Captcha must match above text (case sensitive)'));
					}
				} else {
					callback(new Error('Captcha is Required'));
				}
			};
			var validateWaiver = (rule, value, callback) => {
				if (value) {
					callback();
				} else {
					callback(new Error('Waiver must be Accepted'));
				}
			};
			var validateOpenIceSelected = (rule, value, callback) => {
			    value = this.form.openiceselected;
                if (value) {
                    if (this.FormDefinition ('LinkToTeam') == 'y') {
                        var newSelected = 0;
                        for (let i = 0; i < value.length; i++) {
                            if (!value[i].FormDataID) {
                                newSelected = 1;
                                break;
                            }
                        }
                        if (newSelected == 0) {
                            callback(new Error("One Ice Rental is Required"));
                        }
                    } else {
                        if (value.length == 0) {
                            callback(new Error("One Ice Rental is Required"));
                        }
                    }
                    if (this.FormDefinition('OpenIceType') == 'p') {
                        for (let i = 0; i < this.form.openiceselected.length; i++) {
                            for (let j = 0; j < this.form.openiceselected[i].Attendees.length; j++) {
                                if (this.form.openiceselected[i].Attendees[j].FirstName == '' || this.form.openiceselected[i].Attendees[j].LastName == '') {
                                    callback(new Error("All Attendee First/Last Names are required."));
                                    break;
                                }
                            }
                        }
                    }

                } else if (this.isRequired('openice')) {
                    callback(new Error("One Ice Rental is Required"));
                }
                callback();
            }
			var validateDOB = (rule, value, callback) => {
				if (value) {
					var date = new Date();
					var parts = value.split('-');
					let validDate = true;
					let validDays = 0;
                    if (parts[0].length !=4 || parts[1].length > 2 || parts[2].length > 2) {
                        validDate = false;
                    }
                    if (parts[0] < 1900 || parts[0] > date.getFullYear()) {
						validDate = false;
					}
					if (parts[1] < 1 || parts[1] > 12) {
						validDate = false;
					}

					switch (parseInt(parts[1])) {
						case 2 :
							validDays = (parts[0] % 4 == 0 && parts[0] % 100) || parts[0] % 400 == 0 ? 29 : 28;
							break;
						case 4 : case 6 : case 9 : case 11 :
							validDays =  30;
							break;
						default :
							validDays =  31;
							break;
					}
					if (parts[2] < 1 || parts[2] > validDays) {
						validDate = false;
					}
					if (!validDate ) {
						callback(new Error("Player's DOB is invalid"));
					} else {
						callback();
					}
				} else if (this.isRequired('playerdob')) {
					callback(new Error("Player's DOB is Required"));
				} else {
					callback();
				}
			};
            var validatePlayerRAC = (rule, value, callback) => {
                if (value) {
                    if (this.player) {
                        if (this.player.PlayerID > 0) {
                            callback();
                        } else {
                            this.playerregistrationapprovalcoderequired = true;
                            callback(new Error(""));
                        }
                    } else {
                        callback();
                    }
                } else if (this.isRequired('playerregistrationapprovalcode')) {
                    this.playerregistrationapprovalcoderequired = true;
                    callback(new Error(""));
                } else {
                    callback();
                }
            };
			var validatePaymentCardNumber = (rule, value, callback) => {
				if (value) {
					var allowcards = this.FormDefinition('AllowedCards');
					if (this.isVisa) {
						if (allowcards.indexOf('Visa') === -1) {
							callback(new Error('Visa is not Supported'));
						}
					} else if (this.isMastercard) {
						if (allowcards.indexOf('Mastercard') === -1) {
							callback(new Error('Mastercard is not Supported'));
						}
					} else if (this.isAmex) {
						if (allowcards.indexOf('Amex') === -1) {
							callback(new Error('Amex is not Supported'));
						}
					} else if (this.isDiscover) {
						if (allowcards.indexOf('Discover') === -1) {
							callback(new Error('Discover is not Supported'));
						}
					}
					callback();

				} else if (this.isRequired('paymentdetails')) {
					callback(new Error('Credit Card Number is Required'));
				} else {
					callback();
				}
			};
            return {
                currentStatus : STATUS_INITIAL,
			    Teams : [],
                SelectedTeamID : '',
                disableTeam :  false,
                FormPrograms : [],
                FormProgramTeams : [],
				StateProvinceCodes : [],
			    Months : [1,2,3,4,5,6,7,8,9,10,11,12],
			    currentYear : 2018,
                form : {PaymentAmount : 0, PlayerDOB : '', openiceselected :[]},
                formDefinition : {},
				FormDefinitionID: '',
			    activeStep: 0,
			    sameAddress : false,
			    stepStatus:['process','','','','','','',''],
                stepShow : [true,true,true,true,true,true,true],
				completed : false,
				confirmationMessage:'',
			    loading : true,
			    Params : {},
				CustomValues : [],
				PaymentAmounts : [],
                PaymentFields : [],
                BasePaymentAmount : 0,
				AllowPaymentInput : true,
                player :'',
                search : '',
                searchDates : '',
                searchMainLocationName : '',
                isEmbed : false,
                MainLocationNames : [],
                Organizations : [],
                disableOrganization : false,
                OpenIce : [],
                TeamOpenIce : [],
                IceSelectOrder : [],
                formHasData : true,
                playerregistrationapprovalcodeinvalid : false,
                playerregistrationapprovalcoderequired : false,
                playerregistrationapprovalcodeerror : false,
                playerregistrationapprovalcodedisable : false,
                PlayerRegistrationApprovalCodeErrorMessage : 'Player Registration No. is invalid', 
	            captcharesult : false,
                rules: {
                    BasicPhone: [
                        { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                    PhoneEvening: [
                        { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                    PhoneDaytime: [
                        { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                    CellPhoneNumber: [
                        { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                    ExpiryDate: [
                        { validator: validateExpiryDate, trigger: 'blur' }
                    ],
	                CVV: [
		                { validator: validateCVV, trigger: 'blur' }
	                ],
	                waiver: [
		                { validator: validateWaiver, trigger: 'blur' }
	                ],
	                PlayerDOB: [
		                { validator: validateDOB, trigger: 'blur' }
	                ],
                    openiceselected: [
                        { validator: validateOpenIceSelected , trigger: 'blur' }
                    ],
	                PaymentCardNumber: [
		                { validator: validatePaymentCardNumber, trigger: 'blur' }
	                ],
	                captchavalue: [
		                { validator: validateCaptcha, trigger: 'blur' }
	                ],
	                PlayerRegistrationApprovalCode: [
		                { validator: validatePlayerRAC, trigger: 'blur' }
	                ],
                    
                }
			}
		},
		props:["config", "parentrefs"],
	    computed: {
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
			pageFooter () {
				return '© ' + (new Date()).getFullYear() + ' ' + this.config.Params.SiteName;
			},
			Years () {
				var currYear = new Date().getFullYear().toString().substr(-2);
				var years = [];
				for (let i=0; i < 8; i++) {
					years.push(currYear - (-i));
				}
				return years;
			},
			isVisa () {
				if (this.form.PaymentCardNumber) {
					return (this.form.PaymentCardNumber.charAt(0) == 4 ? true : false);
				} else {
					return false;
				}
			},
			isMastercard () {
				if (this.form.PaymentCardNumber) {
					return (this.form.PaymentCardNumber.charAt(0) == 5 ? true : false);
				} else {
					return false;
				}
			},
			isAmex () {
				if (this.form.PaymentCardNumber) {
					return (this.form.PaymentCardNumber.charAt(0) == 3 ? true : false);
				} else {
					return false;
				}
			},
			isDiscover () {
				if (this.form.PaymentCardNumber) {
					return (this.form.PaymentCardNumber.charAt(0) == 6 ? true : false);
				} else {
					return false;
				}
			},
			playername () {
				return this.Form.PlayerFirstName + ' ' + this.Form.PlayerLastName;
			},
            isMobile () {
                if ( navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i))
                {
                    return true;
                }
                else {
                    return false;
                }
            },
            rentalsSelected () {
			    if (this.FormDefinition ('LinkToTeam') == 'y') {
                    if (this.SelectedTeamID == '') {
                        return 0;
                    }
                }
                return (this.form.openiceselected ? this.form.openiceselected.length : 0);
            },
            maxHeight () {
                var maxHeight = this.FormDefinition('MaxHeight');
                return (maxHeight && !isNaN(maxHeight) ? maxHeight : 500);
            },
		    currencySign () {
			    return Util.currencySign(this.config);
		    },
		},
		methods: {
			isCaptchaValid (value) {
				this.captcharesult = value;
			},
		    programChanged () {
                if (this.FormDefinition ('MultiTeam') != 'y') {
                    this.form['TeamID'] = '';
                }
            },
            teamChanged () {
                if (this.FormDefinition ('LinkToTeam') == 'y') {
                    this.SelectedTeamID = this.form.TeamID;
                    this.SetTeamOpenIce();
                }
            },
            organizationChanged () {


            },
            SetTeamOpenIce () {
                this.IceSelectOrder = [];
                if (this.FormDefinition ('LinkToTeam') == 'y') {
                    this.TeamOpenIce = [];
                    for (let i = 0; i < this.OpenIce.length; i++) {
                        if (this.SelectedTeamID == '') {
                            if (this.OpenIce[i].FormDataID == 'H' ) {
                                //no team selected, all historical is ignored
                                continue;
                            }
                        } else {
                            if ((this.OpenIce[i].FormDataID == 'H' || this.OpenIce[i].FormDataID == 'X') && !this.OpenIce[i].TeamIDs) {
                                //historical or booked but no TeamID, ignore
                                continue;
                            } else if ((this.OpenIce[i].FormDataID == 'H' || this.OpenIce[i].FormDataID == 'X') && this.OpenIce[i].TeamIDs != this.SelectedTeamID) {
                                //historical or booked, but not team selected, ignore
                                continue;
                            }
                        }
                        this.TeamOpenIce.push(this.OpenIce[i]);
                        //store historical ice for this team
                        if (this.OpenIce[i].FormDataID == 'H' || this.OpenIce[i].FormDataID == 'X') {
                            this.IceSelectOrder.push(this.OpenIce[i].CalendarSlotID);
                        }
                    }
                    this.selectionChanged();
                } else {
                    //ignore historical ice
                    this.TeamOpenIce = [];
                    for (let i = 0; i < this.OpenIce.length; i++) {
                        if (this.OpenIce[i].FormDataID != 'H') {
                            this.TeamOpenIce.push(this.OpenIce[i]);
                        }
                    }
                }
            },
            tableRowClassName({row, rowIndex}) {
                if (row.FormDataID) {
                    return 'booked';
                }
            },
            sortTimeSlotGameDate (a,b) {
                var ret = parseInt(a.GameDate.replace(/-/g, '')) - parseInt(b.GameDate.replace(/-/g, ''));
                if (ret == 0) {
                    ret = parseInt(a.StartSeconds) - parseInt(b.StartSeconds);
                }
                return ret;
            },
            sortTimeSlotGameTime (a,b) {
                if (a.GameDate && b.GameDate) {
                    let ret = parseInt(a.StartSeconds) - parseInt(b.StartSeconds);
                    if (ret == 0) {
                        ret = parseInt(a.GameDate.replace(/-/g, '')) - parseInt(b.GameDate.replace(/-/g, ''));
                    }
                    return ret;
                } else {
                    return 0;
                }
            },
            formatPrice(value) {
                return Util.formatPrice(this.config, value , '');
            },
            selectionChanged(iceSelected) {
                this.form.openiceselected = [];
                var recalculate = false;
                for (let i = 0; i < this.TeamOpenIce.length; i++) {
                    if (iceSelected) {
                        if (iceSelected.CalendarSlotID == this.TeamOpenIce[i].CalendarSlotID) {
                            if (iceSelected.selected) {
                                //this is a new slot, so add to the selected order
                                this.IceSelectOrder.push(iceSelected.CalendarSlotID);
                            } else {
                                //this ice is being deselected, so remove
                                //if it is not the last slot, need to recalculate cost for the slots based on order
                                //selected
                                var idx = this.IceSelectOrder.indexOf(iceSelected.CalendarSlotID);
                                if (idx == this.IceSelectOrder.length - 1) {
                                    recalculate = false;
                                }
                                this.IceSelectOrder.splice(idx,1);
                            }
                        }
                    }
                    if (this.TeamOpenIce[i].selected) {
                        if (this.FormDefinition ('LinkToTeam') == 'y') {
                            if (!this.TeamOpenIce[i].hasOwnProperty('TeamIDs') || this.TeamOpenIce[i].TeamIDs == '') {
                                //no teams assigned, so consider it selected
                                this.form.openiceselected.push(this.TeamOpenIce[i]);
                            } else {
                                //slot has a team assign, see if it matches and considering history
                                if (this.TeamOpenIce[i].TeamIDs == this.SelectedTeamID && this.FormDefinition('ConsiderHistory') == 'y') {
                                    this.form.openiceselected.push(this.TeamOpenIce[i]);
                                }
                            }
                        } else {
                            if (!this.TeamOpenIce[i].FormDataID) {
                                this.form.openiceselected.push(this.TeamOpenIce[i]);
                            }
                        }
                    }
                }
                this.calcOpenIceFees();
                this.calcPaymentAmount();
            },
            calcOpenIceFees() {
                //first go through all existing and update pricing in case some rental was removed.
                for (let k = 0; k < this.IceSelectOrder.length; k++) {
                    for (let j = 0; j < this.form.openiceselected.length; j++) {
                        if (this.form.openiceselected[j].CalendarSlotID != this.IceSelectOrder[k]) {
                            continue;
                        }
                        var rentals = k+1;
                        var discountedFee = -1;
                        var discountedPct = -1;
                        var custompayments = (this.formDefinition.CustomPayments ? this.formDefinition.CustomPayments : []);

                        for (let i = 0; i < custompayments.length; i++) {
                            if (!custompayments[i].FromRentalNumber || isNaN(custompayments[i].FromRentalNumber)) {
                                custompayments[i].FromRentalNumber = 1;
                            }
                            if (!custompayments[i].ToRentalNumber || isNaN(custompayments[i].ToRentalNumber)) {
                                custompayments[i].ToRentalNumber = 100000;
                            }
                            if (!custompayments[i].DiscountPct || isNaN(custompayments[i].DiscountPct)) {
                                custompayments[i].DiscountPct = 0;
                            }
                            if (!custompayments[i].FlatFee || isNaN(custompayments[i].FlatFee)) {
                                custompayments[i].FlatFee = 0;
                            }

                            if (rentals >= custompayments[i].FromRentalNumber && rentals <= custompayments[i].ToRentalNumber) {
                                if (custompayments[i].DiscountPct > 0) {
                                    discountedPct = custompayments[i].DiscountPct;
                                } else {
                                    discountedFee = custompayments[i].FlatFee;
                                }
                                break;
                            }
                        }
                        //so update the selected one
                        for (let i = 0; i < this.TeamOpenIce.length; i++) {
                            if (this.form.openiceselected[j].CalendarSlotID == this.TeamOpenIce[i].CalendarSlotID) {
                                if (isNaN(this.TeamOpenIce[i].Fee)) {
                                    this.TeamOpenIce[i].Fee = 0;
                                }
                                if (discountedFee != -1) {
                                    this.TeamOpenIce[i].DiscountedFee = (discountedFee < this.TeamOpenIce[i].Fee ? discountedFee : this.TeamOpenIce[i].Fee);
                                } else if (discountedPct != -1) {
                                    var calcFee = Math.round(this.TeamOpenIce[i].Fee * ((100 - discountedPct))) / 100;
                                    this.TeamOpenIce[i].DiscountedFee = (calcFee < this.TeamOpenIce[i].Fee ? calcFee : this.TeamOpenIce[i].Fee);
                                } else {
                                    this.TeamOpenIce[i].DiscountedFee = this.TeamOpenIce[i].Fee;
                                }

                                this.form.openiceselected[j].Fee = this.TeamOpenIce[i].Fee;
                                this.form.openiceselected[j].DiscountedFee = this.TeamOpenIce[i].DiscountedFee;
                            }
                        }
                    }
                }
                var rentals = (this.form.openiceselected ? this.form.openiceselected.length : 0) + 1;
                var discountedFee = -1;
                var discountedPct = -1;
                var custompayments = (this.formDefinition.CustomPayments ? this.formDefinition.CustomPayments : []);

                for (let i = 0; i < custompayments.length; i++) {
                    if (!custompayments[i].FromRentalNumber || isNaN(custompayments[i].FromRentalNumber)) {
                        custompayments[i].FromRentalNumber = 1;
                    }
                    if (!custompayments[i].ToRentalNumber || isNaN(custompayments[i].ToRentalNumber)) {
                        custompayments[i].ToRentalNumber = 100000;
                    }
                    if (!custompayments[i].DiscountPct || isNaN(custompayments[i].DiscountPct)) {
                        custompayments[i].DiscountPct = 0;
                    }
                    if (!custompayments[i].FlatFee || isNaN(custompayments[i].FlatFee)) {
                        custompayments[i].FlatFee = 0;
                    }

                    if (rentals >= custompayments[i].FromRentalNumber && rentals <= custompayments[i].ToRentalNumber) {
                        if (custompayments[i].DiscountPct > 0) {
                            discountedPct = custompayments[i].DiscountPct;
                        } else {
                            discountedFee = custompayments[i].FlatFee;
                        }
                        break;
                    }
                }
                //so update rate for all those not selected
                for (let i = 0; i < this.TeamOpenIce.length; i++) {
                    if (isNaN(this.TeamOpenIce[i].Fee)) {
                        this.TeamOpenIce[i].Fee = 0;
                    }
                    if (!this.TeamOpenIce[i].selected) {
                        if (discountedFee != -1) {
                            this.TeamOpenIce[i].DiscountedFee = (discountedFee < this.TeamOpenIce[i].Fee ? discountedFee : this.TeamOpenIce[i].Fee);
                        } else if (discountedPct != -1) {
                            var calcFee = Math.round(this.TeamOpenIce[i].Fee * ((100 - discountedPct))) / 100;
                            this.TeamOpenIce[i].DiscountedFee = (calcFee < this.TeamOpenIce[i].Fee ? calcFee : this.TeamOpenIce[i].Fee);
                        } else {
                            this.TeamOpenIce[i].DiscountedFee = this.TeamOpenIce[i].Fee;
                        }
                    }
                }
            },
            setSelectedRows() {
                if (this.form.openiceselected) {
                    for (let i = 0; i < this.form.openiceselected.length; i++) {
                        for (let j = 0; j < this.OpenIce.length; j++) {
                            if (this.OpenIce[j].CalendarSlotID == this.form.openiceselected[i].CalendarSlotID) {
                                this.OpenIce[j].selected = true;
                            }
                        }
                    }
                }
                this.calcPaymentAmount();
            },
            NumAttendeesChanged (CalendarSlotID) {
                for (let i = 0; i < this.OpenIce.length; i++) {
                    if (this.OpenIce[i].CalendarSlotID == CalendarSlotID) {
                        if (isNaN(this.OpenIce[i]['NumAttendees'])) {
                            this.OpenIce[i]['NumAttendees'] = '';
                        } else {
                            if (parseInt(this.OpenIce[i]['NumAttendees']) > parseInt(this.OpenIce[i].Availability)) {
                                this.OpenIce[i]['NumAttendees'] = parseInt(this.OpenIce[i].Availability);
                            }
                        }
                        for (let j = 0; j < this.OpenIce[i]['NumAttendees']; j++) {
                            if (this.OpenIce[i]['Attendees'].length < j + 1) {
                                this.OpenIce[i]['Attendees'].push({FirstName:'', LastName:''});
                            }
                        }
                        if (this.OpenIce[i]['NumAttendees'] != this.OpenIce[i]['Attendees'].length) {
                            this.OpenIce[i]['Attendees'].splice(this.OpenIce[i]['NumAttendees']);
                        }
                        break;
                    }
                }
                this.form.openiceselected = [];
                for (let i = 0; i < this.OpenIce.length; i++) {
                    if (parseInt(this.OpenIce[i]['NumAttendees']) > 0) {
                        this.form.openiceselected.push(this.OpenIce[i]);
                    }
                }
                this.calcPaymentAmount();
            },
			isRequired(Field) {
				var steps = this.FormDefinition ('FormSteps');
				for (let i=0; i <  steps.length; i++) {
					for (let j=0; j <  steps[i].StepFields.length; j++) {
						if (steps[i].StepFields[j].value == Field) {
							if (steps[i].StepFields[j].required) {
								return steps[i].StepFields[j].required;
							} else {
								return false;
							}
						}
					}
				}
				return false;
			},
            nextButtonText(index) {
                var validSteps = 0;

                for (let i = 0; i < this.FormDefinition ('FormSteps').length; i++) {
                    if (this.showCondition('Step' + (i + 1))) {
                        validSteps++;
                    }
                }
                return ((validSteps - 1) == (this.activeStep) ? 'Finish' : 'Next Step');
            },
			stepIncludesField(field, item, index) {
				for (let i=0; i <  item.StepFields.length; i++) {
					if (item.StepFields[i].value == field) {
						return true;
					}
				}
                return false;
            },
            stepName(index) {
                var stepnumber = 1;
                for (let i = 0; i < index; i++) {
                    if (this.showCondition('Step' + (i + 1))) {
                        stepnumber++;
                    }
                }
                return 'Step ' + stepnumber;
            },
		    FormDefinition (formField) {
                if (this.formDefinition[formField]) {
                    return this.formDefinition[formField];
                } else {
                    return '';
                }
            },
			stepValidation (step) {
				if (this.$refs['paymentForm'] && this.$refs['paymentForm'].validate) {
					let self = this;
					this.$refs['paymentForm'].validate((valid) => {
						if (valid) {
							self.stepStatus[step] = 'success';
						} else {
							self.stepStatus[step] = 'process';
						}
						self.processValidateResponse(step);
					});
				} else {
				    this.stepStatus[step] = (step == 0 ? 'success' : '');
					this.processValidateResponse(step);
			    }

			},
			next () {
                this.stepValidation (this.activeStep);
			},
			processValidateResponse(step) {
				if (this.stepStatus[step] == 'success') {
					for (let i = this.activeStep + 1; i <= this.FormDefinition('FormSteps').length; i++) {
						if (this.showCondition('Step' + (i + 1))) {
							if (i >= (this.FormDefinition('FormSteps').length)) {
								this.submitForm();
								break;
							} else {
								this.activeStep = i;
								window.scrollTo(0, 0);
								break;
							}
						}
					}
				}
			},
			prev () {
                for (let i = this.activeStep - 1; i >= 0; i--) {
                    if (this.showCondition('Step' + (i + 1))) {
                        this.activeStep = i;
                        break;
                    }
                }
                this.$nextTick(function() {
                    this.setSelectedRows();
                });
                window.scrollTo(0,0);
			},
			processSameAddress () {
				if (this.sameAddress) {
					this.form.PaymentStreet = this.form.AddressStreet;
					this.form.PaymentApt = this.form.AddressApt;
					this.form.PaymentCity = this.form.AddressCity;
					this.form.PaymentState = this.form.AddressState;
					this.form.PaymentZipCode = this.form.AddressZipCode;
					this.form.PaymentCountry = this.form.AddressCountry;
				} else {
					this.form.PaymentStreet = '';
					this.form.PaymentApt = '';
					this.form.PaymentCity = '';
					this.form.PaymentState = '';
					this.form.PaymentZipCode = '';
					this.form.PaymentCountry = '';
				}
			},
			setAddressCountry(val) {
				for (let i=0; i < this.StateProvinceCodes.length; i++) {
					for (let j=0; j < this.StateProvinceCodes[i].States.length; j++) {
						if (this.StateProvinceCodes[i].States[j].StateProvinceCodeShortName == val) {
							this.form.AddressCountry = this.StateProvinceCodes[i].States[j].Country;
							break;
						}
					}
				}
			},
			setPaymentCountry(val) {
				for (let i=0; i < this.StateProvinceCodes.length; i++) {
					for (let j=0; j < this.StateProvinceCodes[i].States.length; j++) {
						if (this.StateProvinceCodes[i].States[j].StateProvinceCodeShortName == val) {
							this.form.PaymentCountry = this.StateProvinceCodes[i].States[j].Country;
							break;
						}
					}
				}
			},
			getTeams () {
                this.Teams = [];
                this.FormPrograms = [];
                this.FormProgramTeams = [];
                var tables = ['FormProgramTeams', 'FormPrograms', 'Teams', 'Organizations'];

				axios.post('/index/tableData', {tables: tables, selector: this.FormDefinition('TeamSelector'), programorganizationselector: this.FormDefinition('ProgramSelector')},
				)
                .then(response => {
                    if (response.data.result == 'success') {
                        for (let value of tables) {
                            this[value] = response.data[value];
                        }
                        if (!this.isEmbed) {
                            this.$stopProgressBar(this.parentrefs);
                        }
                        if (this.TeamID) {
                            this.form.TeamID = this.TeamID;
                        }
                    } else {
                        this.$failProgressBar(this.parentrefs);
                    }
                }).catch(response => {
                    this.$failProgressBar(this.parentrefs);
                });
			},

			getInitialData () {
				var tables = ['StateProvinceCodes'];
				axios.post('/index/tableData', {'tables': tables},
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
							this.getFormData();
						} else {
							this.$failProgressBar(this.parentrefs);
						}
					}).catch(response => {
					this.$failProgressBar(this.parentrefs);
				});
			},
			buildTeams (values) {
				this.Teams = [];
				var TeamNames = values.split(",");
				for (let i=0; i < TeamNames.length; i++) {
					this.Teams.push( { 'TeamName' : TeamNames[i], 'TeamID' : TeamNames[i] } );
				}
			},
			evaluateYearLiterals (years) {
				return `${this.currentYear + years}`;
			},
			calcPaymentAmount() {
                this.form.PaymentAmount = this.BasePaymentAmount;
			    for (let f = 0; f < this.PaymentFields.length; f++) {
                    var selectedItem = this.form[this.PaymentFields[f]];
                    if (Array.isArray(selectedItem)) {
                        //multi-select, go through them all
                        for (let i = 0; i < selectedItem.length; i++) {
                            var index = this.CustomValues[f].indexOf(selectedItem[i]);
                            if (index >= 0) {
                                this.form.PaymentAmount += parseFloat(this.PaymentAmounts[f][index]);
                            }
                        }
                    } else {
                        var index = this.CustomValues[f].indexOf(selectedItem);
                        if (index >= 0) {
                            this.form.PaymentAmount += parseFloat(this.PaymentAmounts[f][index]);
                        }
                    }
                }
			    if (this.form.openiceselected && this.form.openiceselected.length > 0) {
                    for (let i = 0; i < this.form.openiceselected.length; i++) {
                        if (this.FormDefinition('OpenIceType') == 'r') {
                            if (this.form.openiceselected[i].FormDataID != 'X' && this.form.openiceselected[i].FormDataID != 'H') {
                                //let's see if custom amounts
                                if (this.FormDefinition('CustomPayments') && this.FormDefinition('CustomPayments').length > 0) {
                                    this.form.PaymentAmount += parseFloat(this.form.openiceselected[i].DiscountedFee);
                                } else {
                                    this.form.PaymentAmount += parseFloat(this.form.openiceselected[i].Fee);
                                }
                            }
                        } else {
                            this.form.PaymentAmount += parseInt(this.form.openiceselected[i].NumAttendees) * parseFloat(this.form.openiceselected[i].Fee);
                        }
                    }
                }
			},
			showCondition (field) {
				var valid = true;
				var conditions = this.FormDefinition ('FormConditions');
                var compValue = '';
                var compVar = '';
                var evalCondition = '';
				if (conditions) {
					var steps = this.FormDefinition ('FormSteps');
					for (let i = 0; i < conditions.length; i++) {
                        compValue = '';
                        compVar = '';
						if (conditions[i].ShowField == field) {
							for (let j = 0; j < steps.length; j++) {
								for (let k = 0; k < steps[j].StepFields.length; k++) {
									if (steps[j].StepFields[k].value == conditions[i].ConditionField) {
                                        let compValue = (steps[j].StepFields[k].value == 'paymentamount' ? this.form['PaymentAmount'] : this.form[steps[j].StepFields[k].value]);
                                        if (!compValue) {
											compValue = '';
										}
                                        if (evalCondition) {
                                            if (conditions[i].ConditionJoin == '||') {
                                                evalCondition = '(' + evalCondition + ' || ';
                                                evalCondition += " '" + compValue + "' " + conditions[i].ConditionExpression + " '" + conditions[i].ConditionValue + "') ";
                                            } else {
                                                evalCondition = evalCondition + ' && ';
                                                evalCondition += " '" + compValue + "' " + conditions[i].ConditionExpression + " '" + conditions[i].ConditionValue + "' ";
                                            }
                                        } else {
                                            evalCondition += " '" + compValue + "' " + conditions[i].ConditionExpression + " '" + conditions[i].ConditionValue + "' ";
                                        }
									}
								}
							}
						}
					}
                    if (evalCondition) {
                        let check = false;
                        eval("check = (" + evalCondition + ");");
                        if (!check) {
                            valid = false;
                        }
                    }
				}
                if (field.indexOf('Step') > -1) {
                    var num = field.replace('Step','');
                    if (valid != this.stepShow[num]) {
                        this.stepKey++;
                        this.stepShow[num] = valid;
                    }
                }
				return valid;
			},
			getFormData () {
                axios.post('/formdata/get', {'FormName': this.$route.params.formname.toLowerCase()},
                )
                .then(response => {
                    if (response.data.result == 'success') {
                    	this.FormDefinitionID = response.data.FormDefinitionID;
	                    let def = response.data.formDefinition;
                        if (response.data.OpenIce) {
                            this.OpenIce = response.data.OpenIce;
                        }
                        if (response.data.MainLocationNames) {
                            this.MainLocationNames = response.data.MainLocationNames;
                        }
                        var openice = false;
                        for (var i = 0; i < def.FormSteps.length; i++) {
                            for (var j = 0; j < def.FormSteps[i].StepFields.length; j++) {
                                if (def.FormSteps[i].StepFields[j].value == 'openice') {
                                    openice = true;
                                    break;
                                }
                            }
                        }
                        if (openice) {
                            if (def.OpenIceType == "p") {
                                if (this.OpenIce.length == 0) {
                                    this.formHasData = false;
                                }
                            } else {
                                this.formHasData = false;
                                this.calcOpenIceFees();
                                for (var i = 0; i < this.OpenIce.length; i++) {
                                    if (!this.OpenIce[i].FormDataID) {
                                        this.formHasData = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if (def.CustomFields) {
	                        for (var i = 0; i < def.CustomFields.length; i++) {
		                        if (def.CustomFields[i].Values) {
		                        	if (def.CustomFields[i].Type == 'select' || def.CustomFields[i].Type == 'multiple' || def.CustomFields[i].Type == 'radio' || def.CustomFields[i].Type == 'multiplecheckbox') {
				                        def.CustomFields[i].Values = def.CustomFields[i].Values.split(',').map(function (item) {
					                        return item.trim();
				                        });
				                        if (def.CustomFields[i].Type == 'multiple' || def.CustomFields[i].Type == 'multiplecheckbox') {
                                            //form value needs to start as array
                                            this.form[def.CustomFields[i].Value] = [];
                                        } else {
											this.form[def.CustomFields[i].Value] = '';
				                        }
			                        }
		                        }
                                if (def.CustomFields[i].Type == 'phone') {
                                    this.rules[def.CustomFields[i].Value] =  this.rules.BasicPhone;
                                }
		                        if (def.CustomFields[i].PaymentAmounts) {
			                        this.PaymentAmounts.push(def.CustomFields[i].PaymentAmounts.split(',').map(function(item) { return item.trim(); }));
			                        this.CustomValues.push(def.CustomFields[i].Values);
			                        this.PaymentFields.push(def.CustomFields[i].Value);
			                        this.AllowPaymentInput = false;
		                        }
	                        }
	                    }
                        if (this.OpenIce.length > 0) {
                            for (let i = 0; i < this.OpenIce.length; i++) {
                                if (this.OpenIce[i].TeamIDs && this.OpenIce[i].FormDataID) {
                                    this.OpenIce[i].selected = true;
                                }
                            }
                            this.AllowPaymentInput = false;
                        }
						this.formDefinition = def;
                        this.setStyles();
                        if (this.formDefinition.FormPayment) {
                            this.form.PaymentAmount = parseInt(this.formDefinition.FormPayment);
                        } else {
                            this.form.PaymentAmount = 0;
                        }
                        this.BasePaymentAmount = this.form.PaymentAmount;
						if (this.formDefinition.TeamValues) {
							this.buildTeams(this.formDefinition.TeamValues);
						} else {
                            this.getTeams();
                        }
	                    document.title = this.formDefinition.FormTitle;
                        if (this.formHasData) {
                            this.calcOpenIceFees();
                        }
						this.calcPaymentAmount();
                        if (!this.isEmbed) {
                            this.$stopProgressBar(this.parentrefs);
                        }
                        if (this.$route.query.regcode) {
                            this.playerregistrationapprovalcodedisable = true;
                            this.form.PlayerRegistrationApprovalCode = this.$route.query.regcode;
                            this.validatePlayerRegistrationApprovalCode();
                        }
                        if (this.$route.query.TeamID) {
                            this.TeamID = this.$route.query.TeamID;
                            this.form.TeamID = this.$route.query.TeamID;
                            this.SelectedTeamID = this.$route.query.TeamID;
                            this.disableTeam = true;
                        }                        
                        if (this.$route.query.OrganizationID) {
                            this.form.OrganizationID = this.$route.query.OrganizationID;
                            this.disableOrganization = true;
                        } else if (this.$route.query.organizationID) {
                            this.form.OrganizationID = this.$route.query.organizationID;
                            this.disableOrganization = true;
                        }
                        this.SetTeamOpenIce();
                    } else {
                        this.$failProgressBar(this.parentrefs);
                        this.displayModal('This form cannot be loaded');
                    }
	                this.loading = false;
                }).catch(response => {
                    this.$failProgressBar(this.parentrefs);
                    this.activated = false;
                    this.displayPopup('This form cannot be loaded');
	                this.loading = false;
                });
			},
            validatePlayerRegistrationApprovalCode () {
                if (this.form.PlayerRegistrationApprovalCode) {
                    axios.post('/playerregistration/validateplayerregistrationapprovalcode', {RegistrationApprovalCode: this.form.PlayerRegistrationApprovalCode, SeasonID: this.formDefinition.SeasonID},
                    )
                        .then(response => {
                            if (response.data.result == 'success') {
                                this.playerregistrationapprovalcodeinvalid = false;
                                this.playerregistrationapprovalcoderequired = false;
                                this.playerregistrationapprovalcodeerror = false;
                                this.player = response.data.player;
                                this.form['PlayerFirstName'] = this.player.FirstName;
                                this.form['PlayerLastName'] = this.player.LastName;
                                this.form['PlayerID'] = this.player.PlayerID;
                                this.form['Email'] = this.player.EmailAddress;
                                if (this.player.Params.DOB) {
                                    this.form['PlayerDOB'] = this.player.Params.DOB.slice(0,10);
                                }
                                if (this.player.PlayerTypeName) {
                                    this.form['PlayerTypeName'] = this.player.PlayerTypeName;
                                }
                                if (this.player.TeamID) {
                                    this.form['TeamID'] = this.player.TeamID;
                                }
                            } else {
                                this.player = {PlayerID : 0};
                                this.form['PlayerFirstName'] = '';
                                this.form['PlayerLastName'] = '';
                                this.form['PlayerDOB'] = '';
                                this.form['PlayerTypeName'] = '';
                                this.form['TeamID'] = '';
                                this.form['Email'] = '';
                                this.playerregistrationapprovalcodeinvalid = true;
                                this.playerregistrationapprovalcoderequired = false;
                                this.playerregistrationapprovalcodeerror = true;
                                if (response.data.message) {
                                    this.PlayerRegistrationApprovalCodeErrorMessage = response.data.message;
                                }
                            }
                            this.$refs['paymentForm'].validate;
                        }).catch(response => {
                            this.player = {PlayerID : 0};
                    });
                } else {
                    this.player = {PlayerID : 0};
	                this.form['PlayerFirstName'] = '';
	                this.form['PlayerLastName'] = '';
	                this.form['PlayerDOB'] = '';
	                this.form['PlayerTypeName'] = '';
	                this.form['TeamID'] = '';
                    this.playerregistrationapprovalcoderequired = true;
                    this.playerregistrationapprovalcodeinvalid = false;
                    this.playerregistrationapprovalcodeerror = true;
                }
            },
			submitForm () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
                this.$startProgressBar(this.parentrefs);
				this.currentStatus = STATUS_SAVING;
				this.loading = true;
				if (this.player.TeamID && this.formDefinition.MultiTeam == 'y') {
                    this.player.TeamID = JSON.stringify(this.player.TeamID);
                }
				if (this.FormDefinition('LinkToTeam') == 'y' ) {
				    if (!this.form.TeamID) {
                        if (this.TeamID) {
                            this.form.TeamID = this.TeamID;
                        } else {
                            var teams = (this.FormDefinition('ShowTeamProgram') != 'y' ? this.Teams : this.FormProgramTeams[this.form.ProgramID]);
                            for (let i = 0; i < teams.length; i++) {
                                if (teams[i]['TeamName'] == this.form.TeamName) {
                                    this.form.TeamID = teams[i]['TeamID'];
                                    break;
                                }
                            }
                        }
                        if (!this.form.TeamID) {
                            this.displayModal('The form is having issue purchasing for this team.');
                            return false;
                        }
                    }
                }


				axios.post('/formdata/submit', {'FormDefinitionID' : this.FormDefinitionID, 'FormName': this.$route.params.formname.toLowerCase(), 'Params' : this.form, TableName : (this.player && this.player.PlayerID > 0 ? 'Players' : ''), TableID : (this.player ? this.player.PlayerID : 0)}
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.$stopProgressBar(this.parentrefs);
							this.completed = true;
							this.confirmationMessage = response.data.confirmationMessage;
							this.currentStatus = STATUS_SUCCESS;
						} else {
							this.displayPopup(response.data.message);
                            if (response.data.OpenIce) {
                                this.OpenIce = response.data.OpenIce;
                            }
							this.$failProgressBar(this.parentrefs);
							this.currentStatus = STATUS_FAILED;
						}
						this.loading = false;
					}).catch(response => {
						this.$failProgressBar(this.parentrefs);
						this.loading = false;
						this.currentStatus = STATUS_FAILED;
				});
			},
            setStyles () {
                let style = document.createElement('style')
                document.head.append(style)
                style.innerText = '#app #formdisplay .el-table th, #app #formdisplay .el-table__fixed-footer-wrapper tbody td, #app #formdisplay .el-table__footer-wrapper tbody td, #app #formdisplay .el-table__header-wrapper tbody td { background-color: ' + this.FormDefinition ('HeaderColor') + '; color: #FFFFFF;}';

            },
	        displayPopup (message) {
                this.$alert(message, 'Entry Error', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'OK',
                });
            },
		},
		mounted () {

            this.currentYear = (new Date()).getFullYear();
            this.getInitialData();
            if (this.$route.query.embed) {
                this.isEmbed = true;
            } else {
                this.isEmbed = false;
                this.$startProgressBar(this.parentrefs);
            }
        }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#formdisplay.embed {
    background-color: transparent !important;
}
#formdisplay.embed .el-step__description {
    font-size: 14px;
}
#app.formdisplay .page-wrapper {
	margin: 0px;
}

#app.formdisplay .container-fluid {
	padding-left: 0;
}
#app #formdisplay .el-radio-group {
    display: block;
}
#app #formdisplay .el-radio-group label {
    display: inline;
}
#app #formdisplay .el-input.is-disabled .el-input__inner {
    color: #495057;
}
#app #formdisplay .FormDate.disabled {
    border-color: #E4E7ED;
    background-color: #F5F7FA;
}
#app #formdisplay .smallNumber input {
    width: 40px;
}
#app #formdisplay .el-input.smallNumber {
    width: 60px;
}
#app #formdisplay .booked .cell {
    color: #999999;
}
#app #formdisplay.el-date-editor--daterange.el-input__inner {
    width: 95%;
}
#app #formdisplay .el-button {
	width: 124px;
}
#app #formdisplay .FormDate div.el-input__wrapper {
	height: 32px;
}
</style>
<style scoped>
.wizard-form {
	margin: 20px 15px;
	width: 100%;
}
.row.form-group  {
	margin-top: 15px;
}
.el-steps.el-steps--horizontal {
	width: 100%;
}
.el-input, input {
	max-width: 500px;
}
#app div.el-select, #app div.el-textarea {
	width: 100%;
	max-width: 500px;
}
#app div.el-select.search {
    width: 95%;
}
.expiryDate .el-select {
	width: 85px;
}
.expiryDate input {
	width: 85px;
}
.expiryDate {
	width: 100%;
}
.ccTypes {
	width: 100%;
	font-size: 30px;
}
.formMessage {
	font-size: 90%;
	margin-bottom: 15px;
}
.templates {
	display: none;
}
#app input[type="text"], #app select {
	min-width: 300px;
	margin-right: 50%;
}
#app .formLogo img {
	height: 50px;
	margin: 10px 0 0 10px;
	display: inline-block;
}
#app .formTitle {
	margin-left: 15px;
	display: inline-block;
	font-size: 20px;
	font-weight: 800;
	line-height: 70px;
}
#app button {
	margin-top: 20px;
}

#app .page-footer {
	color: #FFF;
	font-size: 12px;
	font-weight: 600;
	height: 20px;
	line-height: 20px;
	position: fixed;
	bottom: 0;
	z-index: 100;
	text-align: center;
}
#app .page-body {
	margin: 60px 0px;
}

#app .custom-control-label {
	padding-top: 12px;
	font-size: 14px;
	font-weight: 800;
}
#app .custom-control-label::before,
#app .custom-control-label::after {
	top: .8rem;
	width: 1.25rem;
	height: 1.25rem;
}
#app .custom-control {
	margin-left: 10px;
}
.waiver {
	width: 90%;
	min-width: 300px;
	height: 100px;
	overflow:auto;
	border:1px solid #ced4da;
	font-size:12px;
	border-radius: 0.25rem;
	background-color: #fff;
}
.successMessage {
	color: #009900;
	border: 2px solid #333333;
	background-color: #f9f9f9;
	padding: 20px;
	width: 80%;
}
#app label {
	display: block;
}
#app p {
	width: 100%;
}
.FormDate {
	margin-right: 50%;
	min-width: 0px;
	width: 185px;
	height: 28px;
}
.sorry {
	margin-top: 20px;
    margin-left: 20px;
	font-size: 16px;
	font-weight: 800;
}
#app div.zipcode {
	width: 150px;
}
#app .search {
    width: 95%;
    margin-bottom: 3px;
}
.description {
    margin-left: 5px;
    font-size: 10px;
    line-height: 12px;
}
.is-error input.el-input__inner {
    border-color: #F56C6C
}
.MaximumRentals {
    font-size: 16px;
    font-weight: 600;
    color: #dc3545;
    padding: 10px 0px;
}
.ccTypes span {
	margin-right: 5px;
}
.InputPaymentAmount {
	width: 200px;
}
div.vue_client_recaptcha {
	display: flex;
	justify-content: left;
	flex-direction: row;
	border: 1px solid #999999;
	margin-top: 10px;
	width: 232px;
}
.vue_client_recaptcha_input {
	width: 232px;
}
.ServiceCharge {
    position: absolute;
    color: #dc3545;
    top: 16px;
    left: 229px;
    width: 200px;
}
</style>
